// import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportEmployeeEmissions from '@/pages/report-employee-emissions/ReportEmployeeEmissions'

export default [
  {
    path: '/report-employee-emissions/:userToken/:date',
    name: 'ReportEmployeeEmissions',
    component: ReportEmployeeEmissions,
    meta: {
      hideMainMenu: true,
      isFromApp: false,
      role: {
        sectorId: 'public',
      },
    }
  },
    {
    path: '/report-employee-emissions/:userToken/:date/fapp',
    name: 'ReportEmployeeEmissionsFromApp',
    component: ReportEmployeeEmissions,
    meta: {
      hideMainMenu: true,
      isFromApp: true,
      role: {
        sectorId: 'public',
      },
    }
  },
]